import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MgsFieldDefaultComponent } from './mgs-field-default.component';
import { NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MgsNormHandlerComponent } from './mgs-norm-handler.component';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'mng-mgs-field-shortstring-component',
  imports: [NgStyle, MatFormField, MatError, ReactiveFormsModule, MgsNormHandlerComponent, MatInput],
  template: `
    <div style="width: 100%; display: flex; gap: 20px; align-items: center;" [ngStyle]="style">
      <mat-form-field
        [ngStyle]="style"
        style="width: 100%;"
        [appearance]="appearance"
        color="accent"
        [attr.id]="defId"
        [floatLabel]="floatLabel"
        subscriptSizing="dynamic"
      >
        <input
          matInput
          [formControl]="formControl"
          [required]="uiAttribut.attribut.mandatory"
          [pattern]="pattern"
          autocomplete="off"
          (keydown)="onKeydown($event)"
        />
        @if (formControl.errors) {
          <mat-error>{{ getErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <div style="width: 300px;">
        @if (uiAttribut.attribut.normDefinition) {
          <mng-mgs-norm-handler-component [uiAttribut]="uiAttribut" />
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsFieldShortstringComponent extends MgsFieldDefaultComponent {
  pattern: string | RegExp;
  constructor() {
    super();
  }

  attributSet() {
    super.attributSet();
    if (this.definition?.validation?.regexPattern) {
      try {
        this.pattern = new RegExp(this.definition.validation.regexPattern);
      } catch (e) {
        console.error('Regex für', this.definition.label, e);
      }
    }
  }

  getErrorMessage(): string {
    if (this.definition?.validation?.message) {
      return this.definition?.validation?.message;
    } else {
      return this.formControl.errors[0];
    }
  }
}
